<!-- src/views/panelMantenimiento/PanelMantenimiento.vue -->
<template>
  <section class="wrap" v-if="$canView && $canView('superadministrador')">
    <header class="top">
      <h1>Panel de control</h1>
      <p>Configuración global para mantenimiento, security mode y ajustes especiales.</p>
    </header>

    <div class="grid">
      <MantenimientoCard />
      <SecurityModeCard />
      <!-- luego: <LoginBackgroundCard /> -->
    </div>
  </section>

  <section class="wrap" v-else>
    <header class="top">
      <h1>Acceso restringido</h1>
      <p>Solo superadministradores.</p>
    </header>
  </section>
</template>

<script>
import MantenimientoCard from './Components/MantenimientoCard.vue';
import SecurityModeCard from './Components/SecurityModeCard.vue';

export default {
  name: 'PanelMantenimiento',
  components: { MantenimientoCard, SecurityModeCard }
};
</script>

<style lang="sass" scoped>
.wrap
  width: min(1100px, 92vw)
  margin: 0 auto
  padding: 22px 0
  text-align: left

.top
  margin-bottom: 14px
  h1
    margin: 0
    font-size: 1.35rem
    font-weight: 1000
    color: #0f172a
  p
    margin: 6px 0 0
    color: #64748b
    font-weight: 600

.grid
  display: grid
  grid-template-columns: 1fr
  gap: 14px
  @media (min-width: 900px)
    grid-template-columns: 1fr 1fr
</style>